import type { StanDataColumn } from '@/components/core-components/StanDataRow/StanDataRow.types';

/**
 * Grid column percentages for broadcast list
 */
export const BROADCAST_GRID_COLUMNS = {
    name: 36,
    sent: 12,
    opens: 12,
    clicks: 12,
    status: 28,
} as const;

/**
 * Header column definitions for broadcast list
 */
export const BROADCAST_HEADER_COLUMNS: StanDataColumn[] = [
    {
        id: 'name',
        name: 'Name',
        width: BROADCAST_GRID_COLUMNS.name,
    },
    {
        id: 'sent',
        name: 'Sent',
        width: BROADCAST_GRID_COLUMNS.sent,
        className: 'hidden md:block',
    },
    {
        id: 'opens',
        name: 'Opens',
        width: BROADCAST_GRID_COLUMNS.opens,
        className: 'hidden md:block',
    },
    {
        id: 'clicks',
        name: 'Clicks',
        width: BROADCAST_GRID_COLUMNS.clicks,
        className: 'hidden md:block',
    },
    {
        id: 'status',
        name: 'Status',
        width: BROADCAST_GRID_COLUMNS.status,
        className: 'hidden md:block',
    },
];

/**
 * Generate grid template string from column percentages
 */
export function getGridTemplate(): string {
    return Object.values(BROADCAST_GRID_COLUMNS)
        .map(width => `${width}%`)
        .join(' ');
}
